import styled from '@emotion/styled';

export const PropertyImage = styled.img`
  padding: 0;
`;
